module.exports = __webpack_public_path__ + "img/reserve.59815446.png";